import _ from "lodash";
import { Types } from "./fyorinActions";



const fyorinReducers = (state, action) => {
    switch (action.type) {
        case Types.FYORIN_UPDATE_EMPLOYEE: {

            let newState = _.cloneDeep(state);

            if (action.fyorinId) {
                newState.employee.employeeDetails.fyorinId = action.fyorinId
            }

            if (action.pending) {
                newState.employee.employeeDetails.fyorinPending = action.pending
            } else if (newState.employee.employeeDetails.fyorinPending) {
                delete newState.employee?.emplyoeeDetails?.fyorinPending
            }

            return newState;
        }
        case Types.FYORIN_SYNCING_STATUS: {

            let newState = _.cloneDeep(state);

            if (action.unsyncedEmployees) {
                newState.integration.payment.fyorin.unsyncedEmployees = action.unsyncedEmployees
            }
            if (action.error) {
                newState.integration.payment.fyorin.syncError = action.error
            }
            if (action.syncingStatus) {
                newState.integration.payment.fyorin.syncingStatus = action.syncingStatus
            }
            return newState;
        }
        case Types.FYORIN_PAYMENT_STAGE: {
            let newState = _.cloneDeep(state);

            newState.integration.payment.fyorin.stage = action.stage

            return newState;
        }
        case Types.FYORIN_PAY_PERIOD: {
            let newState = _.cloneDeep(state);

            const index = newState?.payPeriods?.periods?.map(period => period.id).indexOf(action.payPeriodId)

            if (action.fyorinId) {
                if (newState.payPeriods.periods) {
                    newState.payPeriods.periods[index].fyorinId = action.fyorinId
                }
                if (newState.payroll?.payPeriodDetails?.id == action.payPeriodId && !newState.payroll.payPeriodDetails.fyorinId) {
                    newState.payroll.payPeriodDetails.fyorinId = action.fyorinId
                }
            }
            if (action.fyorinStatus) {
                if (newState.payPeriods.periods) {
                    newState.payPeriods.periods[index].fyorinStatus = action.fyorinStatus
                }
                if (newState.payroll?.payPeriodDetails?.id == action.payPeriodId) {
                    newState.payroll.payPeriodDetails.fyorinStatus = action.fyorinStatus
                }
            }

            return newState;
        }

        default:
            return state;
    }
};

export default fyorinReducers;